import gql from 'graphql-tag'

export const ZONE = gql`
  fragment Zone on Zone {
    label
  }
`
